/* eslint-disable no-console */
import wrapper from 'wrapper';
import trackScrollPosition from './utils/trackScrollPosition';
import events from './utils/events-emitter';
import isInViewport from './utils/isInViewport';
import AnimationToggle from './components/animation-toggle/animation-toggle';
import sharedVariables from './shared_variables';
import FilterButtons from './components/filter-buttons/filter-buttons';
import Profile from './components/profile/profile';
import BackToTopBtn from './components/back-to-top-button/back-to-top';
import ParallaxHeader from './components/parallax-header/parallax-header';

let hasLogged = false;
const variant = wrapper.select('#variant-b') ? 'b' : 'a';
const filterBtnsContainer = wrapper.select('.filter-buttons__wrapper');

// add tracking to OJs
wrapper.selectAll('.onward-journey').forEach((li) => {
    li.addEventListener('click', () => wrapper.trackUserAction('onward journey clicked', li.querySelector('a').href));
});

if (sharedVariables.animation_toggle) new AnimationToggle();

wrapper.markPageAsLoaded();
new FilterButtons();
new Profile();
new BackToTopBtn();

__lazyLoad();

wrapper.onOptimizedScroll(() => {
    trackScrollPosition();
    if (isInViewport(filterBtnsContainer) && !hasLogged) {
        wrapper.trackUserAction('reached categories box', variant)
        hasLogged = true;
    }
});
